import { defineMessages } from 'react-intl-next';

export default defineMessages({
    articleIconLabel: {
        defaultMessage: 'Article icon',
        description: 'Text for label on article icon',
        id: 'cv.search.resource-icon.article-icon-label',
    },
    requestFormIconLabel: {
        defaultMessage: 'Request form icon',
        description: 'Text for label on request form icon',
        id: 'cv.search.resource-icon.request-form-icon-label',
    },
    portalIconLabel: {
        defaultMessage: 'Portal icon',
        description: 'Text for label on portal icon',
        id: 'cv.search.resource-icon.portal-icon-label',
    },
    helpResourceIconLabel: {
        defaultMessage: 'Help resource icon',
        description: 'Text for label on help resource icon',
        id: 'cv.search.resource-icon.help-resource-icon-label',
    },
});
